export default "__VITE_ASSET__CGiv7mdO__"